import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["classes", "InputProps", "ref"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import { RaiseColors } from "componentLibrary";
import { withStyles } from "@mui/styles";
import * as React from "react";
import TextField from "../TextField/TextField";
import { jsx as _jsx } from "react/jsx-runtime";
export default withStyles({
  root: {
    flexWrap: "wrap",
    height: "auto",
    borderRadius: 8,
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid ".concat(RaiseColors.grayscale200)
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid ".concat(RaiseColors.bahama1200)
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "1px solid ".concat(RaiseColors.grayscale900)
    }
  },
  input: {
    width: 1,
    flexGrow: 1,
    padding: "8px 16px",
    fontSize: 14
  }
})(function (_ref) {
  var classes = _ref.classes,
    InputProps = _ref.InputProps,
    ref = _ref.ref,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(TextField, _objectSpread({
    variant: "outlined",
    InputProps: _objectSpread({
      inputRef: ref,
      classes: classes
    }, InputProps),
    fullWidth: true
  }, other));
});